"use strict";

/**
* Реквизит типа «Выбор из справочника» и «Множественный выбор».
* 
* @class WebAccess.components.wrappers.form.requisites.Radio
* @extends WebAccess.components.wrappers.form.requisites.BaseRequisite
* @property {string} name Имя реквизита
* @param {string} requisiteName Имя реквизита
* @param {obbject} data Данные для инициализации реквизита
* @since 5.2.0.2014
*/
(function (global) {

  /**
* @inner
* @since 5.2.0.2014
*/

  var Radio = global.WA.CMP.wrappers.form.requisites.BaseRequisite.extend({
    className: "Radio",

    /**
    * Получить контролы реквизита.
    *
    * @method WebAccess.components.wrappers.form.requisites.Radio#_bindEvents
    * @private
    * @return {array} список jquery объектов
    * @since 5.2.0.2014
    */
    _getControls: function () {
      var me = this;
      var res = [];

      if (me.controlsIds.length == 0 || me.controlsIds[0] == "") return [];

      for (var i = 0; i < me.controlsIds.length; i++) {
        var id = me.controlsIds[i];        
        var selector = '[name="' + id + '"][type="radio"]';
        selector = selector.replaceAll('_', '$');
        var jControl = $(selector);
        res.push(jControl);
      }
      return res;
    },
    //---------------------------------------------------------------------//


    /**
    * Отобразить спиннер внутри контрола реквизита
    * @method WebAccess.components.wrappers.form.requisites.Radio#_showSpinner
    * @since 5.2.0.2014
    * @private
    * @return  WebAccess.components.wrappers.form.requisites.Radio
    */
    _showSpinner: function () {
      var me = this;      
      return me;
    },
    //---------------------------------------------------------------------//

    /**
    * Скрыть спиннер
    * @method WebAccess.components.wrappers.form.requisites.Radio#_hideSpinner
    * @since 5.2.0.2014
    * @private
    * @return  WebAccess.components.wrappers.form.requisites.Radio
    */
    _hideSpinner: function () {
      var me = this;
      return me;
    },
    //---------------------------------------------------------------------//

    /**   
    * Получить значение реквизита.
    *        
    * @method WebAccess.components.wrappers.form.requisites.Radio#getDisplayValue
    * @return {string} Строка, содержащая отображаемое значение реквизита.
    */
    getDisplayValue: function (opt_jControl) {
      if (this._data && this._data.isRendered === false) return this._data.displayValue;
      if (this.controls.length === 0) return;
      return $(this.controls[0]).filter(':checked').next('label').text();

    },
    //---------------------------------------------------------------------//    

    /**   
    * Установить значение отображаемых и неотображаемых реквизитов.
    *
    * @method WebAccess.components.wrappers.form.requisites.Radio#setValue
    * @param value {string} Устанавливаемое значение
    * @param [opt_displayValue] {string} Отображаемое значение
    * @param [opt_needTriggerResult] {string} Вызвать триггер для события типа change
    * @return {WebAccess.components.wrappers.form.requisites.Radio} Текущий объект реквизита – Reference.
    * @since 5.2.0.2014
    */
    setValue: function (value, opt_displayValue, opt_needTriggerResult) {
      var me = this;
      opt_needTriggerResult = (opt_needTriggerResult !== false);

      if (this.controls.length === 0) return this._setInvisibleValues(value, opt_displayValue, opt_needTriggerResult);

      $.each(me.controls, function () {
        var jControl = $(this).filter(function () {
          return $(this).val().toLowerCase() === value.toString().toLowerCase();
        })
        jControl.prop('checked', true);
        //if (opt_displayValue) jControl.next('label').text(opt_displayValue);
      });

      this.touch();
      return this;
    },
    //---------------------------------------------------------------------//

    /**
    * @ignore
    * @method WebAccess.components.wrappers.form.requisites.Radio#setDisplayValue
    */
    setDisplayValue: function (displayValue, opt_needTriggerResult) {
      return this;
    },
    //---------------------------------------------------------------------//

    /**
    * Получить значение в поле по его имени.
    *
    * @private
    * @function WebAccess.components.wrappers.form.requisites.Radio#_getControlValue
    * @since 5.2.0.2014
    */
    _getControlValue: function (controlName) {
      if (this.controls.length === 0) return;
      return $(this.controls[0]).filter(':checked').val() === 'True';      
    },
    //---------------------------------------------------------------------//

    /**
    * @method WebAccess.components.wrappers.form.requisites.Radio#setCustomAction
    * @ignore 
    */
    setCustomAction: function() {
      return this;
    }
  });

  global.WA.CMP.wrappers.form.requisites.Radio = Radio;
})(window);